import { Button, Dropdown, message } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DotsMenu } from "../../../Icons/DotsMenu";
import { DeleteConfirmation } from "../AddRequest/DeleteModal";
import { useState } from "react";
import { useDeleteData } from "../../../Network/useDeleteData";
import { useTranslation } from "react-i18next";

export const RequestServices = ({ services, results }: any) => {
  const navigate = useNavigate();
  const { requestId } = useParams();
  const [deletedService, setDeletedService] = useState<any>();
  const { t, i18n } = useTranslation();

  const { mutate: deleteItem } = useDeleteData({
    url: `service-request/services`,
    options: {
      onSuccess: () => {
        message.success(t("requestServices.deleteSuccess"));
      },
      onError: (error) => {
        message.error(t("requestServices.deleteError"));
        console.error("Failed to delete item:", error);
      },
    },
  });

  return (
    <div className="request-services-wrapper list">
      <p>
        {t("requestServices.serviceBreakdown")}
        <Link
          style={{ display: "inline-block", marginLeft: "5px" }}
          to={`/add-request/${requestId}`}
        >
          {t("requestServices.addMore")}
        </Link>
      </p>

      {services?.map((service) => (
        <div key={service?.id} className="service-breakdown-wrapper">
          <p className="service-name">
            {service?.service.name?.[i18n.language || "en"]}
          </p>

          <div className="service-provider-service-wrapper">
            <span>
              <img
                src={
                  service?.serviceProvider?.logoUrl ||
                  "/assets/providers/mokhtabar.png"
                }
                alt="logo-url"
                onError={(e) => {
                  (e.target as HTMLImageElement).src =
                    "/assets/providers/mokhtabar.png";
                }}
              />
            </span>
            <p>
              {service?.serviceProvider?.name?.[i18n.language || "en"]}{" "}
              <span style={{ display: "flex", gap: "10px" }}>
                {results?.length ? (
                  <Button
                    type="link"
                    className="result-link"
                    size="small"
                    onClick={() =>
                      navigate(`/view-results-request/${requestId}`)
                    }
                  >
                    {t("requestServices.result")}
                  </Button>
                ) : null}
                {service?.price}
                <div className="branch-menu-action">
                  <Dropdown
                    menu={{
                      items: [
                        {
                          label: (
                            <p
                              className="menu-item Delete"
                              onClick={() =>
                                setDeletedService(service?.service)
                              }
                            >
                              {t("requestServices.delete")}
                            </p>
                          ),
                          key: "0",
                        },
                      ],
                    }}
                    trigger={["click"]}
                  >
                    <span style={{ cursor: "pointer" }}>
                      <DotsMenu />
                    </span>
                  </Dropdown>
                </div>
              </span>
            </p>
          </div>
        </div>
      ))}

      {deletedService && (
        <DeleteConfirmation
          onCloseModal={() => setDeletedService(null)}
          provider={{ ...deletedService, logoUrl: "" }}
          onDelete={async () =>
            // @ts-ignore
            await deleteItem({
              serviceRequestId: +requestId,
              serviceIds: [+deletedService?.id],
            })
          }
          title={t("requestServices.delete")}
        />
      )}
    </div>
  );
};
